export const WITHOUT_SCROLL_CLASS = 'without-scroll';
